export const Constantes = {
  BASE: process.env.MS_AUTENTICACION,
  TOKEN: process.env.TOKEN,
};
